"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphQLClient = exports.ClientError = void 0;
const tslib_1 = require("tslib");
const http_client_1 = require("@wix/http-client");
class ClientError extends Error {
    constructor(response, request) {
        const message = `${ClientError.extractMessage(response)}: ${JSON.stringify({
            response,
            request,
        })}`;
        super(message);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, ClientError);
        }
    }
    static extractMessage(response) {
        try {
            return response.errors[0].message;
        }
        catch (e) {
            return `GraphQL Error (Code: ${response.status})`;
        }
    }
}
exports.ClientError = ClientError;
class Batcher {
    constructor(flush) {
        this.flush = flush;
        this.buffer = [];
        this.timeout = null;
    }
    batch(data) {
        if (this.timeout === null) {
            this.timeout = setTimeout(() => {
                this.flush(this.buffer);
                this.buffer = [];
                this.timeout = null;
            }, 0);
        }
        this.buffer.push(data);
    }
}
class GraphQLClient {
    constructor(baseURL, options) {
        this.makeRequest = (batchedData) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { headers, logger } = this.options;
            const payload = batchedData.map((d) => d.data);
            const oneQuery = payload.length === 1;
            const body = oneQuery ? payload[0] : payload;
            try {
                const response = yield this.httpClient.post('/', body, {
                    headers,
                });
                const { data } = response;
                const results = oneQuery ? [data] : data;
                results.forEach((result, ind) => {
                    const batchedD = batchedData[ind];
                    if (response.status === 200 && !result.errors && result.data) {
                        // batchedD.resolve({ ...result, headers, status });
                        batchedD.resolve(result.data);
                    }
                    else {
                        const errorResult = typeof result === 'string' ? { error: result } : result;
                        batchedD.reject(new ClientError(Object.assign(Object.assign({}, errorResult), { status: response.status, headers: response.headers }), {
                            query: batchedD.data.query,
                            variables: batchedD.data.variables,
                        }));
                    }
                });
            }
            catch (e) {
                logger === null || logger === void 0 ? void 0 : logger.error('graphql error', e, { error: e, body });
                batchedData.map((b) => b.reject(e));
            }
        });
        this.options = options || {};
        this.batcher = new Batcher(this.makeRequest);
        this.httpClient = new http_client_1.HttpClient({
            baseURL,
        });
    }
    request(query, variables) {
        let resolve, reject;
        const promise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });
        const data = {
            query,
            variables: variables ? variables : undefined,
        };
        this.batcher.batch({ data, resolve: resolve, reject: reject });
        return promise;
    }
    setHeaders(headers) {
        this.options.headers = headers;
        return this;
    }
    setHeader(key, value) {
        const { headers } = this.options;
        if (headers) {
            headers[key] = value;
        }
        else {
            this.options.headers = { [key]: value };
        }
        return this;
    }
}
exports.GraphQLClient = GraphQLClient;
//# sourceMappingURL=request.js.map